import { CrudTable, StatusBadge } from "@/components/shared";

export default function Team() {
  const columns = [
    { key: "employee_id", label: "Emp ID", render: (r) => <span className="font-mono-ync text-[#C9A24B]">{r.employee_id}</span> },
    { key: "name", label: "Name" },
    { key: "role", label: "Work Role", render: (r) => r.role ? <StatusBadge value={r.role} /> : <span className="text-[#C9A24B] text-xs">Select role in Settings &gt; Team</span> },
    { key: "branch", label: "Branch", render: (r) => r.branch || (r.branches || []).join(", ") || "—" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Google Account" },
    { key: "branches", label: "Branches", render: (r) => (r.branches || []).join(", ") || "—" },
    { key: "joining_date", label: "Joined", render: (r) => r.joining_date?.slice(0, 10) || "—" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "remarks", label: "Remarks" },
  ];
  const fields = [
    { key: "name", label: "Name", type: "text" },
    { key: "role", label: "Work Role", type: "select", options: ["Operational Manager", "Relationship Executive"] },
    { key: "branch", label: "Branch (select or type new)", type: "branch" },
    { key: "phone", label: "Phone (optional)", type: "text" },
    { key: "email", label: "Google Account Email (optional)", type: "text" },
    { key: "joining_date", label: "Joining Date", type: "date" },
    { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
    { key: "remarks", label: "Remarks", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="team" endpoint="team" filledBy={false}
      title="Team Members"
      subtitle="Add Manager / Relationship Executive. Deactivate instead of delete — history safe rahe. New member turant tab, goals aur dashboard filter me aa jata hai."
      columns={columns} fields={fields}
      defaults={{ status: "Active", role: "Relationship Executive", branch: "", branches: [] }}
    />
  );
}
